module.exports = __webpack_public_path__ + "img/GabrielleNadeau-Headshot-BW-Web.7d58d1f6.jpg";